import { render } from "./root1_ag(act).vue?vue&type=template&id=76f4d5c8"
const script = {}

import "./root1_ag(act).vue?vue&type=style&index=0&id=76f4d5c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__